// Routing
export const GO_TO_SCREEN = 'GO_TO_SCREEN';
export const GO_BACK = 'GO_BACK';
export const GO_TO_SCREEN_AND_RESET_HISTORY = 'GO_TO_SCREEN_AND_RESET_HISTORY';
export const SET_HISTORY_SCREEN_STATE = 'SET_HISTORY_SCREEN_STATE';
export const EXIT_GAME = 'EXIT GAME';
// Game Settings
export const SET_GAME_SETTINGS = 'SET_GAME_SETTINGS';
// Tutorials
export const COMPLETE_TUTORIAL = 'COMPLETE_TUTORIAL';
export const RESET_TUTORIALS = 'RESET_TUTORIALS';
// Scores
export const UPDATE_OVERALL_SCORES = 'UPDATE_OVERALL_SCORES';
export const FAIL_WEEK = 'FAIL_WEEK';
// settings
export const CHANGE_FONT_SIZE = 'CHANGE_FONT_SIZE';
export const TOGGLE_AUDIO = 'TOGGLE_AUDIO';
export const TOGGLE_TIMED_GAMES = 'TOGGLE_TIMED_GAMES';

// time
export const PROGRESS_TIME = 'PROGRESS_TIME';
export const PROGRESS_DAY = 'PROGRESS_DAY';
export const SUBMIT_GAME_PLAYED = 'SUBMIT_GAME_PLAYED';

// calendar
export const SET_CALENDAR = 'SET_CALENDAR';
export const SET_PHONE_CALL = 'SET_PHONE_CALL';
export const REMOVE_PHONE_CALL = 'REMOVE_PHONE_CALL';
// messages
export const SET_MESSAGES_INDEXES = 'SET_MESSAGES_INDEXES';
export const SET_ALL_MESSAGES = 'SET_ALL_MESSAGES';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const COMPLETE_MESSAGE = 'COMPLETE_MESSAGE';
// meetings
export const SET_MEETINGS_INDEXES = 'SET_MEETINGS_INDEXES';
export const SET_ALL_MEETINGS = 'SET_ALL_MEETINGS';
export const ADD_MEETING = 'ADD_MEETING';
export const COMPLETE_MEETING = 'COMPLETE_MEETING';
